import moment from 'moment'

/**
 * A service that provides data access for the employee resource.
 * @param {IHttpService} $http An HTTP client.
 * @param {IQService} $q The Q promise library service.
 * @param {string} apexApiUrl The prefix for the Apex API url.
 * @returns {any} An instance of the service.
 */
export function EmployeeService($http, $q, apexApiUrl, utilityService) {
    'ngInject'
    // Cache certain data for the lifetime of the current page.
    const cache = {};
    return {
        hasUniqueSSN: hasUniqueSSN,
        hasOnboardingPermission: hasOnboardingPermission,
        retrieveIdentity: retrieveIdentity,
        retrieveEmployeeIdentity: retrieveEmployeeIdentity,
        retrieveEmployees: retrieveEmployees,
        retrieveEmployeesPage: retrieveEmployeesPage,
        retrieveEmployeesByRoleName: retrieveEmployeesByRoleName,
        retrieveEmployeesByModuleAdmin: retrieveEmployeesByModuleAdmin,
        retrieveEmployeesByRosterAdmin: retrieveEmployeesByRosterAdmin,
        retrieveNewEmployeeModel: retrieveNewEmployeeModel,
        retrieveNewEmployeeBankInfoModel: retrieveNewEmployeeBankInfoModel,
        retrieveEmployee: retrieveEmployee,
        retrieveOnboardingEmployee: retrieveOnboardingEmployee,
        updateOnboardingEmployee: updateOnboardingEmployee,
        retrieveEmployeeSecuritySettings: retrieveEmployeeSecuritySettings,
        retrieveEmployeeByUsername: retrieveEmployeeByUsername,
        saveEmployee: saveEmployee,
        saveOnboardingEmployee: saveOnboardingEmployee,
        updateEmployeeProfile: updateEmployeeProfile,
        updateEmployeeProfileForOnboarding: updateEmployeeProfileForOnboarding,
        validatePhoneNumber: validatePhoneNumber,
        updateEmployeeSecuritySettings: updateEmployeeSecuritySettings,
        updateEmployeeProfileImage: updateEmployeeProfileImage,
        patchEmployeeProfile: patchEmployeeProfile,
        resendOnboardingEmployee: resendOnboardingEmployee,
        retrieveEmployeeProfile: retrieveEmployeeProfile,
        retrieveTerminationReasons: retrieveTerminationReasons,
        retrieveProfileImageUrl: retrieveProfileImageUrl,
        retrieveGenders: retrieveGenders,
        retrieveEmployeeBankInfo: retrieveEmployeeBankInfo,
        retrieveEmployeeStatuses: retrieveEmployeeStatuses,
        retrieveEmployeeAssignableRoles: retrieveEmployeeAssignableRoles,
        retrieveJobTitles: retrieveJobTitles,
        retrieveBasisOfPay: retrieveBasisOfPay,
        retrieveCompensationProfiles: retrieveCompensationProfiles,
        retrieveAdministeredModules: retrieveAdministeredModules,
        retrieveMaritalStatuses: retrieveMaritalStatuses,
        retrieveWithHolding: retrieveWithHolding,
        updateEmployeeBankInfo: updateEmployeeBankInfo,
        updateEmployeeOnboardingBankInfo: updateEmployeeOnboardingBankInfo,
        isEmailAddressAvailable: isEmailAddressAvailable,
        sendPasswordReminder: sendPasswordReminder,
        mapIcdOfficeEmployeeToDTO: mapIcdOfficeEmployeeToDTO,
        retrievePermissions: retrievePermissions,
        retrieveEmployeeDetails: retrieveEmployeeDetails,
        initOnboardingEmployee: initOnboardingEmployee,
        rehireOnboardingEmployee: rehireOnboardingEmployee,
        revokeOnboardingEmployee: revokeOnboardingEmployee,
        checkIfRequiredFilled: checkIfRequiredFilled,
        checkForTelemapperLink: checkForTelemapperLink,
        checkForDuplicates: checkForDuplicates
    };

    /**
     * Send email to employee for initiating onboarding/sending onboarding email
     * @returns {Promise<any>} 
     */
    function hasUniqueSSN(employeeID, ssn) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/check-unique-ssn/" + employeeID + "/" + ssn,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            //return response.data;
            return true;
        });
    }

    function hasOnboardingPermission() {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/onboarding-permission",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
    /**
     * Check for telemapper link
     * @returns {Promise<boolean>} 
     */
    function checkForTelemapperLink() {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/account-telemapper-linked/",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Send email to employee for initiating onboarding/sending onboarding email
     * @returns {Promise<any>} 
     */
    function checkIfRequiredFilled(employeeID) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/required-filled/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Send email to employee for initiating onboarding/sending onboarding email
     * @returns {Promise<any>} 
     */
    function initOnboardingEmployee(employeeID, sendemail) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/init-onboarding/" + employeeID + "/" + sendemail,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
    /**
         * Send email to employee for rehire process of onboarding/sending onboarding email
         * @returns {Promise<any>} 
         */
    function rehireOnboardingEmployee(employeeID) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/rehire-onboarding/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
    /**
        * Resend email to employee for initiating onboarding/sending onboarding email
        * @returns {Promise<any>} 
        */
    function resendOnboardingEmployee(employeeID) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/send-onboarding/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
    /**
        * Resend email to employee for initiating onboarding/sending onboarding email
        * @returns {Promise<any>} 
        */
    function resendOnboardingEmployee(employeeID) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/send-onboarding/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
    /**
    * revoke onboarding access
    * @returns {Promise<any>} 
    */
    function revokeOnboardingEmployee(employeeID) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/revoke-onboarding/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get the currently logged in user's identity.
     * @returns {Promise<any>} The user's identity.
     */
    function retrieveIdentity() {
        if (cache.identity) {
            return $q.resolve(cache.identity);
        }
        return $http({
            method: "GET",
            url: apexApiUrl + "Home/identity",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            cache.identity = response.data;
            return response.data;
        });
    }

    /**
     * Get the provided user's identity.
     * @returns {Promise<any>} The user's identity.
     */
    function retrieveEmployeeIdentity(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "Home/employee-identity/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Retrieve a list of all employees viewable by the authenticated user.
     * @param {any} query The URL-serializable query.
     * @returns {Promise<any>} The list of all employees that the current user can read.
     */
    function retrieveEmployees(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees",
            params: query || {},
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Get the list of all employees matching the given query, along
     * with paging information according to the given requested index and size.
     * @param {number} pageIndex The 0-indexed page number to request
     * @param {any} query The query object describing the data that should be returned
     * @returns {Promise<any>} A page of employee results.
     */
    function retrieveEmployeesPage(pageIndex, query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees" + "/page/" + pageIndex || 0,
            params: query || {},
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveEmployee(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/" + employeeID
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveOnboardingEmployee(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/onboarding-employee/" + employeeID
        })
            .then(function (response) {
                return response.data;
            });
    }

    function updateOnboardingEmployee(employeeID, employee) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/onboarding-employee/terminate/" + employeeID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(employee)
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveEmployeeSecuritySettings(employeeID) {
        return $http({
            method: "GET",
            url: `${apexApiUrl}/employees/${employeeID}/security`
        }).then(response => response.data);
    }

    function retrieveEmployeeByUsername(username) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees?username=" + username
        })
            .then(function (response) {
                return response.data;
            });
    }

    function saveEmployee(employee, employeeBankInfo) {
        // Create a DTO to convert from the loaded (potentially non-serializable)
        // employee model to a DTO containing the minimal updatable information.
        const employeeDTO = mapEmployeeToDTO(employee, employeeBankInfo);
        if (employee.IsNew) {
            return createEmployee(employeeDTO);
        }
        return updateEmployee(employee.Id, employeeDTO);
    }

    function saveOnboardingEmployee(employee) {
        // Create a DTO to convert from the loaded (potentially non-serializable)
        // employee model to a DTO containing the minimal updatable information.
        const employeeDTO = mapEmployeeToDTO(employee, null);
        if (employee.IsNew) {
            return onboardEmployee(employeeDTO);
        }
        return;
    }

    function createEmployee(employee) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(employee)
        })
            .then(function (response) {
                return response.data;
            });
    }

    function onboardEmployee(employee) {
        return $http({
            method: "POST",
            url: apexApiUrl + "employees/onboard",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(employee)
        })
            .then(function (response) {
                return response.data;
            });
    }

    function updateEmployee(employeeID, employee) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "employees/" + employeeID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(employee)
        }).then(function () {
            return retrieveEmployee(employeeID);
        });
    }

    function updateEmployeeProfile(employeeID, profile, fromOnboarding) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "employees/" + employeeID + "/profile" + (fromOnboarding ? "?fromOnboarding=true" : ""),
            headers: { "Content-Type": "application/json" },
            data: profile
        });
    }

    function updateEmployeeProfileForOnboarding(employeeID, profile) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "employees/" + employeeID + "/onboarding-profile",
            headers: { "Content-Type": "application/json" },
            data: profile
        });
    }

    // Validate a phone number via Twilio Lookup (server-side). Resolves to a boolean:
    // false only when the provider confirms the number is invalid (fail-open otherwise).
    function validatePhoneNumber(phone) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/validate-phone",
            params: { phone: phone }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateEmployeeSecuritySettings(employeeID, securitySettings) {
        return $http({
            method: "PUT",
            url: `${apexApiUrl}/employees/${employeeID}/security`,
            headers: { "Content-Type": "application/json" },
            data: securitySettings
        });
    }

    function updateEmployeeProfileImage(employeeID, profileImage) {
        const formData = new FormData();
        formData.append("profileImage", profileImage);
        return $http({
            method: "PUT",
            url: `${apexApiUrl}/employees/${employeeID}/profile/image`,
            data: formData,
            // The following two lines are required to submit the request as multipart/form-data.
            transformRequest: id => id,
            headers: { "Content-Type": undefined }
        });
    }

    function patchEmployeeProfile(employeeID, profile) {
        return $http({
            method: "PATCH",
            url: apexApiUrl + "employees/" + employeeID + "/profile",
            headers: { "Content-Type": "application/json" },
            data: profile
        });
    }

    function retrieveEmployeeProfile(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/" + employeeID + "/profile"
        })
            .then(function (response) {
                return response.data;
            });

    }

    function retrieveNewEmployeeBankInfoModel() {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/new-bankinfo"
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveNewEmployeeModel() {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/new"
        })
            .then(function (response) {
                return response.data;
            });
    }
    function retrieveEmployeesByRoleName(roleName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/role/" + roleName
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveEmployeesByModuleAdmin(moduleName) {
        return $http.get(apexApiUrl + "employees/module/" + moduleName)
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveEmployeesByRosterAdmin(rosterAdminID) {
        return $http.get(apexApiUrl + "employees/roster" + (rosterAdminID ? "/" + rosterAdminID : ""))
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveEmployeeDetails() {
        return $http.get(apexApiUrl + "employees/details")
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveEmployeeStatuses() {
        return $http.get(apexApiUrl + "employee-statuses")
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveEmployeeAssignableRoles(icdOfficeID) {
        return $http.get(apexApiUrl + "roles/assignable/" + (icdOfficeID || ""))
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveJobTitles() {
        return $http.get(apexApiUrl + "job-titles")
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveBasisOfPay() {
        return $http.get(apexApiUrl + "basis-of-pay")
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveCompensationProfiles() {
        return $http.get(apexApiUrl + "compensation-profiles")
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveAdministeredModules(icdOfficeID) {
        return $http.get(apexApiUrl + "modules/" + (icdOfficeID || ""))
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveTerminationReasons() {
        return $http.get(apexApiUrl + "termination-reasons").then(function (response) {
            return response.data;
        });
    }

    function retrieveProfileImageUrl(employeeID) {
        return $http.get(apexApiUrl + "/employees/" + employeeID + "/profile/image", { responseType: 'blob' })
            .then(function (results) {
                const employeeImage = {};
                const file = new Blob([results.data], { type: results.data.type });
                employeeImage.file = file;

                return new $q(resolve => {
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    fileReader.onload = function (e) {
                        employeeImage.Url = e.target.result;
                        resolve(employeeImage);
                    }
                })
            });
    }

    function retrieveGenders() {
        return $http.get(apexApiUrl + "/enums/genders")
            .then(function (results) {
                return results.data;
            });
    }

    function retrieveEmployeeBankInfo(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/bankinfo/" + employeeID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveMaritalStatuses() {
        return $http({
            method: "GET",
            url: apexApiUrl + "enums/marital-statuses",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveWithHolding() {
        return $http({
            method: "GET",
            url: apexApiUrl + "enums/withholding-types",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateEmployeeBankInfo(employeeID, employeeBankInfo, fromOnboarding) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "employees/bankinfo/" + employeeID + (fromOnboarding ? "?fromOnboarding=true" : ""),
            headers: { "Content-Type": "application/json" },
            data: JSON.stringify(employeeBankInfo)
        }).then(function (response) {
            return response.data;
        });
    }

    function updateEmployeeOnboardingBankInfo(employeeID, employeeBankInfo) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "employees/bankinfo-onboard/" + employeeID,
            headers: { "Content-Type": "application/json" },
            data: JSON.stringify(employeeBankInfo)
        }).then(function (response) {
            return response.data;
        });
    }

    function retrievePermissions(request) {
        return $http({
            method: "GET",
            headers: { Accept: "application/json" },
            url: apexApiUrl + "home/permissions",
            params: request
        }).then(function (response) {
            return response.data;
        });
    }

    function sendPasswordReminder(userName) {
        const queryString = utilityService.queryStringify({
            // The email address is actually the username.
            userName: userName,
            emailAddress: userName,
        });
        return $http({
            method: "POST",
            url: `${apexApiUrl}/home/reset-password${queryString}`
        });
    }

    /**
     * Return whether the following username is available (ie, it has not
     * been claimed by another user).
     * @param {string} emailAddress The username to check.
     * @returns {Promise<boolean>} Whether the username is available.
     */
    function isEmailAddressAvailable(emailAddress) {
        return $http({
            method: "GET",
            //HACK: Add trailing slash to prevent Sophos from blocking the request due to the "extension".
            url: apexApiUrl + "employees/available-emails/" + emailAddress + "/"
        })
            .then(function (response) {
                return response.data;
            });
    }
    /**
    * Return whether the following emailaddress is being used by another user.
    * @param {string} query query with email, icdcorp, icdofficeid, etc
    * @returns Whether a list of EmployeeRosterExportRM
    */
    function checkForDuplicates(query) {
        return $http({
            method: "POST",
            //HACK: Add trailing slash to prevent Sophos from blocking the request due to the "extension".
            url: apexApiUrl + "employees/duplicate-profiles",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(query)
        }).then(function (response) {
            return response.data;
        });
    }


    function mapEmployeeToDTO(employee, employeeBankInfo) {
        var data = {
            FirstName: employee.FirstName,
            MiddleName: employee.MiddleName,
            LastName: employee.LastName,
            UserName: employee.UserName,
            EmailAddress: employee.EmailAddress,
            Password: employee.Password,
            Inactive: employee.Inactive,
            InactiveDate: employee.InactiveDate,
            GlobalSiteID: employee.GlobalSiteID,
            UniqueID: employee.UniqueID,
            ADPEmployeeID: employee.ADPEmployeeID,
            MeridianEmployeeID: employee.MeridianEmployeeID,
            IcdOffices: employee.IcdOffices.map(mapIcdOfficeEmployeeToDTO),
            GlobalRoles: employee.GlobalRoles.reduce(function (res, globalRole) {
                res[globalRole.RoleID] = globalRole.IsInRole;
                return res;
            }, {}),
            SendWelcomeEmail: employee.SendWelcomeEmail,
            EmailOnboarding: employee.EmailOnboarding,
            SmsOnboarding: employee.SmsOnboarding,
            MobilePhone: employee.MobilePhone
        };
        if (employeeBankInfo) {
            data.StateWorkingIn = employeeBankInfo.StateWorkingIn;
        }
        return data;
    }

    function mapIcdOfficeEmployeeToDTO(office) {
        return {
            EmployeeStatusID: office.EmployeeStatusID,
            PayFrequencyID: office.PayFrequencyID,
            BasisOfPayID: office.BasisOfPayID,
            HireDate: office.HireDate ? moment(office.HireDate).format("YYYY-MM-DD") : null,
            TerminationDate: office.EmployeeStatus && !office.EmployeeStatus.AllowPortalAccess
                && office.TerminationDate ? moment(office.TerminationDate).format("YYYY-MM-DD") : null,
            TerminationReasonID: office.EmployeeStatus && !office.EmployeeStatus.AllowPortalAccess
                ? office.TerminationReasonID : null,
            TerminationReasonExtra: office.EmployeeStatus && !office.EmployeeStatus.AllowPortalAccess
                ? office.TerminationReasonExtra : null,
            IcdOfficeID: office.IcdOfficeID,
            JobTitleID: office.JobTitleID,
            PayRate: office.PayRate,
            CommissionThreshold: office.CommissionThreshold,
            CompensationProfileID: office.CompensationProfileID,
            DefaultHours: office.DefaultHours,
            Salary: office.Salary,
            Garnishment: office.Garnishment,
            TimeClock: office.TimeClock,
            RequireBreak: office.RequireBreak,
            IsOnPayroll: office.IsOnPayroll,
            TrackRealTime: office.TrackRealTime,
            Divisions: office.Divisions.map(function (division) {
                return division.Id;
            }),
            Roles: office.Roles,
            AdministeredModules: office.AdministeredModules.length > 0 ? office.AdministeredModules.reduce(function (res, module) {
                res[module.ModuleID] = module.IsModuleAdmin;
                return res;
            }, {}) : {},
            // Onboarding fields.
            OnboardingApplicationID: office.OnboardingApplicationID
        };
    }
}
